import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";

type ConfirmationDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onDeny: () => void;
  title: string;
  question: string;
};

export const ConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  onDeny,
  title,
  question,
}: ConfirmationDialogProps) => {
  return (
    <Dialog open={open} onClose={() => onClose()}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{question}</DialogContent>
      <DialogActions>
        <Button onClick={onDeny} color="secondary">
          No
        </Button>
        <Button onClick={onConfirm} color="secondary">
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};
